import React from 'react';

interface PromotionalBoxProps {
  image: string;
  title: string;
  description: string;
  onClick?: () => void;
  arrowImage: string;
}

const PromotionalBox: React.FC<PromotionalBoxProps> = ({
  image,
  title,
  description,
  onClick,
  arrowImage,
}) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center border border-[#28282A]  rounded-[12px] overflow-hidden h-[92px] cursor-pointer transition-transform duration-300 ease-in-out hover:scale-98 active:scale-95"
    >
      <img src={image} alt={title} className='max-w-[97px] max-h-[92px]'/>

      <div className="flex items-center justify-between gap-[20px] w-full h-full px-[10px] sm:px-[15px] bg-white">
        <div className="flex flex-col justify-start">
          <span className="text-black text-[16px] sm:text-[20px] font-bold">
            {title}
          </span>
          <span className="text-[#808080] text-[10px] sm:text-[12px] mt-[3px] font-medium">
            {description}
          </span>
        </div>

        <img src={arrowImage} alt="arrow" className="w-[32px] h-[32px]" />
      </div>
    </div>
  );
};

export default PromotionalBox;
